import { combinedApi as api } from "../combinedApi";
export const addTagTypes = ["Correlation"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      postCorrelationCalculate: build.mutation<
        PostCorrelationCalculateApiResponse,
        PostCorrelationCalculateApiArg
      >({
        query: (queryArg) => ({
          url: `/Correlation/Calculate`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["Correlation"],
      }),
      getCorrelationList: build.query<
        GetCorrelationListApiResponse,
        GetCorrelationListApiArg
      >({
        query: () => ({ url: `/Correlation/List` }),
        providesTags: ["Correlation"],
      }),
      getCorrelationGet: build.query<
        GetCorrelationGetApiResponse,
        GetCorrelationGetApiArg
      >({
        query: (queryArg) => ({
          url: `/Correlation/Get`,
          params: {
            id: queryArg.id,
            resultType: queryArg.resultType,
            dataField: queryArg.dataField,
            measuringPoint: queryArg.measuringPoint,
          },
        }),
        providesTags: ["Correlation"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as correlationApi };
export type PostCorrelationCalculateApiResponse = /** status 200 OK */ void;
export type PostCorrelationCalculateApiArg = CorrelationRequestDto;
export type GetCorrelationListApiResponse =
  /** status 200 OK */ AnalysisRequestDto[];
export type GetCorrelationListApiArg = void;
export type GetCorrelationGetApiResponse =
  /** status 200 OK */ CellValueDto[][];
export type GetCorrelationGetApiArg = {
  id: number;
  resultType: CorrelationResultType;
  dataField?: number;
  measuringPoint?: string;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export type CorrelationCalculationType =
  | "non"
  | "betweenMessstellen"
  | "betweenKenngroessen"
  | "all";
export type CorrelationResultType = "single" | "count" | "percentage";
export type CorrelationRequestDto = {
  name: string;
  start: string;
  end: string;
  type: CorrelationCalculationType;
  resultType: CorrelationResultType;
  measuringPoints?: string[] | null;
  dataFields?: string[] | null;
  coefficientMinimum?: number | null;
  coefficientMaximum?: number | null;
};
export type ServiceType =
  | "jobPrepareOrFinishe"
  | "datacollector"
  | "irregulardatachecker"
  | "correlationcalculator"
  | "quantilecalculator"
  | "anomalycalculator"
  | "correlationresultcalculator"
  | "trendscalculator"
  | "correlationresultaggregator"
  | "anomalyscorecalculator"
  | "non";
export type AnalysisRequestDto = {
  id: number;
  name: string;
  start: string;
  end: string;
  measuringPoints?: string[] | null;
  dataFields?: string[] | null;
  serviceType?: ServiceType;
  correlationType?: CorrelationCalculationType;
  correlationResultType?: CorrelationResultType;
  coefficientMinimum?: number | null;
  coefficientMaximum?: number | null;
  isVisible?: boolean;
  isDeletable?: boolean;
};
export type CellValueDto = {
  row: string;
  col: string;
  value?: number | null;
};
export const {
  usePostCorrelationCalculateMutation,
  useGetCorrelationListQuery,
  useLazyGetCorrelationListQuery,
  useGetCorrelationGetQuery,
  useLazyGetCorrelationGetQuery,
} = injectedRtkApi;
